import useGetQuery from '_api/queries/useGetQuery';
import { ConstantsIdTitle } from '_api/types';

import { UseGetAllPageSizeProps } from '../types';

export const GET_EQUIPMENT_CONSTANT = 'get-equipment-constant';

export const useGetEquipment = ({ page = 0, size = 100 }: UseGetAllPageSizeProps) =>
  useGetQuery<ConstantsIdTitle[]>(
    () => `/constant/equipments?page=${page}&size=${size}`,
    {},
    [GET_EQUIPMENT_CONSTANT],
    {
      refetchOnWindowFocus: false,
    },
  );
